<div>
  @switch (compatibility) {
    @case (CompatibilityType.AndroidWebView) {
      <div>
        <h2 trans="browser_compatibility.android_web_view.title"></h2>
        <p trans="browser_compatibility.android_web_view.open"></p>
        <ol class="numbered-list">
          <li trans="browser_compatibility.android_web_view.li1"></li>
          <img class="hanging" src="/assets/compatibility/compatibility-screenshot-hamburger.png">
          <li trans="browser_compatibility.android_web_view.li2"></li>
          <img src="/assets/compatibility/compatibility-screenshot-open-in.png">
        </ol>
      </div>
    }
    @case (CompatibilityType.Unsupported) {
      <div>
        <h2 trans="browser_compatibility.unsupported.title"></h2>
        <p trans="browser_compatibility.unsupported.open"></p>
        <p trans="browser_compatibility.unsupported.direction"></p>
      </div>
    }
  }
</div>
